import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const updateCode = createAsyncThunk('numpad/updateCode', async (params) => {
  return params;
})

export const updateIsValid = createAsyncThunk('numpad/updateIsValid', async (params) => {
  return params;
})

export const resetNumpad = createAsyncThunk('numpad/resetNumpad', async (params) => {
  return true;
})

export const numpadSlice = createSlice({
  name: 'numpad',
  initialState: {
    code: "",
    isValid: false
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateCode.fulfilled, (state, action) => {
      state.code = action.payload
    });
    builder.addCase(updateIsValid.fulfilled, (state, action) => {
      state.isValid = action.payload
    });
    builder.addCase(resetNumpad.fulfilled, (state, action) => {
      state.code = "";
      state.isValid = false
    })
  }
})

export default numpadSlice.reducer
